import React from 'react';

const STAGE_STYLES = {
  alpha: 'bg-warning text-dark',
  beta: 'bg-accent text-white', // alt bg-primary
  ga: 'd-none',
};

const stage = (import.meta.env.VITE_DEV_STAGE || 'beta').toLowerCase();

const DevStageIndicator = () => {
  const classes = STAGE_STYLES[stage] || 'bg-secondary text-white';

  if (!classes || classes === 'd-none') return null;

  return (
    <span
      className={`badge ${classes} ms-2`}
      style={{ fontSize: '0.75rem', verticalAlign: 'middle' }}
    >
      {stage.toUpperCase()}
    </span>
  );
};

export default DevStageIndicator;
